import type { PILOT_DATA_FRAMES_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-data-frames-card/pilot-data-frames-card.fr.ts";

export const PILOT_DATA_FRAMES_CARD_ENGLISH_LOCALE = {
  title: "Pilot logs",
} satisfies typeof PILOT_DATA_FRAMES_CARD_FRENCH_LOCALE;
